var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import apiClient from '@utils/api-client';
/**
 * Reads the back-office push-device status from Rails, which reads the
 * notification platform. The browser never talks to the platform directly.
 *
 * DELIBERATELY NOT POLLED, unlike the integration sync-status panels it is
 * modelled on. Those read rows out of our own database, so a 30-second poll is
 * nearly free. Every read here is a live HTTP round trip to the platform on
 * behalf of a support engineer who is looking at one technician — polling would
 * turn an idle open tab into steady traffic against the platform, and would
 * multiply it by every tab left open. A support surface is read when someone
 * asks a question, so it fetches once on mount and offers an explicit Refresh.
 */
const useGetPushDeviceStatus = (statusUrl) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchStatus = useCallback((signal) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const response = yield apiClient.get(statusUrl, { signal });
            setData(response.data);
            setError(null);
        }
        catch (err) {
            if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                setError('load_failed');
            }
        }
        finally {
            if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) {
                setLoading(false);
            }
        }
    }), [statusUrl]);
    useEffect(() => {
        const controller = new AbortController();
        void fetchStatus(controller.signal);
        return () => controller.abort();
    }, [fetchStatus]);
    const refresh = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield fetchStatus();
    }), [fetchStatus]);
    return { data, loading, error, refresh };
};
export default useGetPushDeviceStatus;
